module.exports = __webpack_public_path__ + "img/slide1-m.cbb59f57.png";